import CharCounterTextWidget from 'design-comuni-plone-theme/components/ItaliaTheme/manage/Widgets/CharCounterTextWidget';
import SelectWidget from '@plone/volto/components/manage/Widgets/SelectWidget';

const applyConfig = (config) => {
  config.settings = {
    ...config.settings,
    // matomoSiteId: 'xxxxxxxxx',
    // matomoUrlBase: 'https://ingestion.webanalytics.italia.it/',
    // italiaThemeViewsConfig: {
    //   ...config.settings.italiaThemeViewsConfig,
    //   imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    // },
    siteProperties: {
      /*
        Per tutte le props di siteProperties, può essere definito un oggetto per i siti multilingua, strutturato in questo modo:
        {'default': _valore_della_prop, 'it': _valore_della_prop,...}
        Se l'oggetto non è strutturato in questo modo, viene usato l'oggetto stesso, altrimenti viene preso il valore della corrispondente alla prop della lingua corrente o alla prop 'default' se esiste.
      */
      ...config.settings.siteProperties,
      siteTitle: 'Comune di Sassuolo',
      siteSubtitle: '',
      parentSiteTitle: 'Provincia di Modena',
      parentSiteURL: 'https://www.provincia.modena.it/',
      subsiteParentSiteTitle: 'Comune di Sassuolo',
      // enableCustomerSatisfaction: false, // false per disabilitare
      arLoginUrl:
        'https://portalecittadino.comune.sassuolo.mo.it/rwe2/sso/generic/prelogin.jsp?ELANG=it&IATL=it',
      //arLogoutUrl: '/logout',
      // smallFooterLinks: {
      //   default: [{ title: 'Mappa del sito', url: '/sitemap' }],
      //   it: [{ title: 'Mappa del sito', url: '/it/sitemap' }],
      //   en: [{ title: 'Sitemap', url: '/en/sitemap' }],
      // },
    },

    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
        last_updated: '2023-10-11T17:57:00+00:00',
        text: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.text,
          it: {
            title: 'Usiamo i cookies',
            description:
              "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. I cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Cambia le impostazioni'. Per saperne di più su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/footer/cookie-policy' target='_blank'>Cookie Policy.</a>",
          },
          en: {
            title: 'We use cookies',
            description:
              "This site uses technical navigation and session cookies to ensure a better site navigation service, and analytical cookies to collect information on the use of the site by users. It also uses user profiling cookies for statistical and remarketing purposes. For profiling cookies you can decide whether to enable them or not by clicking on the 'Change settings' button. To find out more, on how to disable cookies or enable only some of them, consult our <a href='/footer/cookie-policy' target='_blank'>Cookie Policy</a>.",
          },
          fr: {
            title: 'We use cookies',
            description:
              "Ce site utilise des cookies techniques de navigation et de session pour assurer un meilleur service de navigation sur le site, et des cookies analytiques pour collecter des informations sur l'utilisation du site par les utilisateurs. Il utilise également des cookies de profilage des utilisateurs à des fins statistiques et de remarketing. Pour les cookies de profilage, vous pouvez décider de les activer ou non en cliquant sur le bouton « Modifier les paramètres ». Pour en savoir plus, sur la façon de désactiver les cookies ou d'en activer seulement certains, consultez notre <a href='/footer/cookie-policy' target='_blank'>Politique des cookies</a>.",
          },
        },
        technical: {
          ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.technical,
          choices: [
            {
              config_key: 'MATOMO',
              text: {
                it: {
                  title: 'Matomo',
                  description:
                    "I cookie di Matomo sono usati per analizzare la navigazione sul sito al fine di migliorarla e fornire all'utente un'esperienza di navigazione migliore possibile.",
                },
                en: {
                  title: 'Matomo',
                  description:
                    'Matomo cookie are used to analyze navigation on the site in order to improve it and provide the user with the best possible browsing experience.',
                },
                fr: {
                  title: 'Matomo',
                  description:
                    "Les cookie de Matomo sont utilisés pour analyser la navigation sur le site afin de l'améliorer et offrir à l'utilisateur la meilleure expérience de navigation possible.",
                },
              },
            },
            // ...config.settings[
            //   'volto-gdpr-privacy'
            // ].defaultPanelConfig.technical.choices.filter(
            //   (f) => f.config_key !== 'GANALYTICS',
            // ),
          ],
        },
      },
    },
  };

  config.widgets.id.title = function (props) {
    if (props.behavior === 'plone.basic.service') {
      return <SelectWidget {...props} />;
    } else {
      return <CharCounterTextWidget {...props} />;
    }
  };

  return config;
};

export default applyConfig;
